import { Box, Button, DialogContentText } from '@mui/material';
import PropTypes from 'prop-types';

import Modal from '../Modal';
import { MESSAGE } from '../../../constants/message';

const ErrorModal = ({ open, onClose, message, title = MESSAGE.GENERIC_ERROR_TITLE, buttonLabel = MESSAGE.OK }) => {
  const safeMessage = message || 'An unexpected error occurred.';

  return (
    <Modal
      open={open && !!safeMessage}
      onClose={onClose}
      title={title}
      titleVariant="subtitle10"
      actionButtons={
        <Box my={3}>
          <Button size="large" variant="contained" onClick={onClose}>
            {buttonLabel}
          </Button>
        </Box>
      }
    >
      <Box>
        <DialogContentText variant="body1">{safeMessage}</DialogContentText>
      </Box>
    </Modal>
  );
};

ErrorModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.string,
  title: PropTypes.string,
  buttonLabel: PropTypes.string,
};

export default ErrorModal;
